import {cs} from "./chain-services";
import {UseState} from "./use-state";
import {chain} from "../utils/fs";
import {limitLength} from "../utils/collections";
import {Static2} from "./static-2";
import {fragments} from "./fragments";
import {Invoke} from "./invoke";

export const RCache = ({serializeKey=v=>v, _key=undefined, load, maxSize=1, next}) => cs(
    ["store", (_, next) => UseState({initValue: [], next})],
    ({store}) => {
        const asyncLoad = async ({key, serializedKey}) => {
            const {value, error} = await (async () => {
                try {
                    const value = await load(key);
                    return {value};
                } catch (error) {
                    return {error};
                }
            })()
            const record = {key: serializedKey, rootKey: _key, value, error};
            store.change((s) => chain(
                [...s, record],
                (_) => limitLength(_, {length: maxSize, cutHead: true}),
            ));
            return record;
        };

        const load2 = ({key, retainOutdatedValue=false, next}) => cs(
            ["key1", (_, next) => next(serializeKey(key))],
            ["lowCache", (_, next) => Static2({next})],
            ["record", ({key1, lowCache}, next) => next((() => {
                const matching = [lowCache.get(), ...store.value].find((r) => r?.key === key1 && r?.rootKey === _key);
                if (matching) {
                    lowCache.set(matching);
                }
                return matching;
            })())],
            ["outdatedRecord", ({lowCache}, next) => next(retainOutdatedValue ? lowCache.get() : null)],
            ({record, outdatedRecord, key1}) => fragments(
                next(chain(
                    record ?? outdatedRecord,
                    (r) => r == null ? {
                        loading: true,
                    } : {
                        value: r.value,
                        error: r.error,
                    },
                )),

                (!record) && (
                    Invoke({
                        action: async () => {
                            record = await asyncLoad({key, serializedKey: key1});
                        },
                    })
                ),
            ),
        );
        return next({
            load: load2,
            load1: ({key, next}) => load2({
                key,
                next: ({value}) => next(value),
            }),
            retrieve: async (key) => {

                const serializedKey = serializeKey(key);
                const record = store.value.find((r) => r.key === serializedKey && r.rootKey === _key);
                if (record) {
                    return record.value;
                }

                return (await asyncLoad({key, serializedKey}))?.value;
            },
        });
    },
);
